<template>
  <div class="about" style="position: relative">
   <SingleRideHeader
      :presentedText="t('deleteUserTitle')"
    />
    <b-container>
      <div class="trip-about-section after_page_header">
        <div class="container">
          <div class="row">
            <!-- <div class="col-lg-7"> -->
              <div class="trip-about-content">
                <h1>
                  {{ t('deleteUserTitle') }}
                </h1>
                <h4>
                  {{ t('deleteUserInstructionLine1') }}
                  avshalom@tripplanner.co.il
                  {{ t('deleteUserInstructionLine2') }}
                </h4>
              </div>
            <!-- </div>             -->
          </div>
        </div>
      </div>
      <!-- End about section -->

      <div class="trip-cta-section">
        <div class="container">
          <div class="trip-cta-wrap">
            <h2>{{ t('aboutContactTitle') }}</h2>
            <div class="trip-cta-menu">
              <ul>
                <li><a href="">{{ t('deleteUserPhone') }}</a></li>
                <li>|</li>
                <li><a href="">{{ t('deleteUserEmail') }}</a></li>
                <li>|</li>
                <li><a href="">{{ t('deleteUserAddress') }}</a></li>
              </ul>
            </div>
            <div class="trip-social">
              <ul>
                <li><a href=""><img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/gui_images%2Fsocial-icon-telegram.svg?alt=media&token=21ecf836-710c-4fba-a69b-c74ca59ec7a5" alt=""></a></li>
                <li><a href=""><img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FDigital_Glyph_Green.svg?alt=media&token=3e052f4e-d82e-482b-b2ed-e3694f2fae1c" alt="" width="32" height="32"></a></li>
                <li><a href=""><img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FFacebook_Logo_Primary.png?alt=media&token=2731adce-75a0-493d-ac5d-94a2913b2aa4" alt="" width="32" height="32"></a></li>
                <li><a href=""><img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/gui_images%2Fsocial-icon-mail.svg?alt=media&token=544ee52a-6eb3-4f89-9900-25560e7f6e98" alt=""></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    
    </b-container>
    <PageFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';
import PageFooter from "@/components/PageFooter.vue";
import SingleRideHeader from "@/components/SingleRideHeader";

export default {
  name: "DeleteUser",
  mixins: [translationMixin],
  components: {
    PageFooter,
    SingleRideHeader,    
  },
  computed: mapGetters(['globalRides', 'userId' ]),
  methods: {}
}
</script>

<style scoped>

.after_page_header{
  margin-top: 20rem;
}
@media (max-width: 991px) {
  .after_page_header{
    margin-top: 15rem;
  }
}

/* about page */
.trip-hero-section.about-page {
  padding: 120px 0 60px;
}

.trip-about-section {
  padding: 0rem 1rem 90px;
}
.trip-about-thumb {
  position: sticky;
  top: 150px;
}
.rounded-image {
  border-radius: 1.5rem;
}
.trip-about-content {
  text-align: right;
  margin-left: 64px;
}
.trip-about-content p{
  font-size: 18px;
  line-height: 24px;
  color: #614646;
}
.trip-cta-section {
  padding-bottom: 90px;
}
.trip-cta-wrap {
  background: rgba(7, 160, 195, 0.1);
  border-radius: 22px;
  padding: 25px;
  text-align: center;
}
.trip-cta-wrap h2{
  font-weight: 600;
  font-size: 40px;
  color: #0D2F29;
  margin-bottom: 40px;
}
.trip-cta-menu {
  margin-bottom: 55px;
}
.trip-cta-menu ul li{
  margin: 0 5px;
  display: inline-block;
}
.trip-cta-menu ul li a{
  font-weight: 600;
  font-size: 24px;
  color: #0D2F29;
}

.trip-social ul li{
  margin: 0 35px;
  display: inline-block;
}
.trip-social ul li:first-child{
  margin-left: 0;
}
.trip-social ul li:last-child{
  margin-right: 0;
}
</style>
